import React, { useState, useEffect, useMemo } from "react"
import { Container, Form, Row, Table } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Select from "react-select"
import Swal from "sweetalert2"
import {
  serviceOption,
} from "utils/common-options"
import { Switch } from "antd"
import axios from "axios"
import configure from "configure"
import Loader from "pages/Separate/Loader"
import { useSelector } from "react-redux"

const EditPortfolio = () => {
  const navigate = useNavigate()

  const { id } = useParams()
  const generalLocation = useSelector(state => state?.location?.locations)
  const [PortfolioName, setPortfolioName] = useState("")
  const [Lead, setLead] = useState("")
  const [SelectedCaseStudies, setSelectedCaseStudies] = useState([])
  const [companyName, setCompanyName] = useState("")
  const [leadEmail, setLeadEmail] = useState("")
  const [leadContact, setLeadContact] = useState("")
  const [website, setWebsite] = useState("")
  const [Ptype, setPtype] = useState(false)
  const [techOptions, setTechOption] = useState([])
  const [Leads, setLeads] = useState([])
  const [CaseStudies, setCaseStudies] = useState([])
  const [FilteredCaseStudies, setFilteredCaseStudies] = useState([])
  let TCasestudies, TLeads

  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    const loadAllData = async () => {
      try {
        await Promise.all([fetchNodeData(), fetchLData()])
        // Only after both succeed
        await fetchportfolio()
      } catch (error) {
        console.error("Error loading data:", error)
      }
    }

    loadAllData()
  }, [])

  async function fetchNodeData() {
    setLoading(true)
    axios
      .get(`${configure.nodeApi}/case-study`)
      .then(res => {
        setLoading(false)
        const formattedOptions = res?.data?.caseStudy?.map(item => ({
          ...item, // keep all original properties
          label: item.project_name,
          value: item.id,
        }))

        setCaseStudies(formattedOptions)
        TCasestudies = formattedOptions
        setFilteredCaseStudies(formattedOptions) // show all by default
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })
  }

  async function fetchLData() {
    setLoading(true)
    axios
      .get(`${configure.nodeApi}/leads`)
      .then(res => {
        setLoading(false)
        const formattedLeads = res?.data?.leads?.map(item => ({
          ...item, // retain all original lead properties
          label: item.company,
          value: item.id,
        }))

        setLeads(formattedLeads)
        TLeads = formattedLeads
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })
  }

  const fetchportfolio = async () => {
    setLoading(true)
    axios
      .get(`${configure.nodeApi}/portfolio/${id}`)
      .then(res => {
        setPortfolioName(res?.data?.portfolio?.portfolio_name)
        const ids =
          res?.data?.portfolio?.caseStudyIds?.split(",").map(id => id.trim()) ||
          []

        const selectedOptions = TCasestudies.filter(
          option => ids.includes(String(option.value)) // force to string for reliable match
        )

        setSelectedCaseStudies(selectedOptions)
        setLead(
          TLeads.filter(item => item.value === res?.data?.portfolio?.lead_id)
        )
        setPtype(res?.data?.portfolio?.is_lead_type)
        setCompanyName(res?.data?.portfolio?.lead_company_name)
        setLeadEmail(res?.data?.portfolio?.lead_email)
        setLeadContact(res?.data?.portfolio?.lead_contact)
        setWebsite(res?.data?.portfolio?.lead_website)
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })
  }

  const [filters, setFilters] = useState({
    location: "",
    service: "",
    technology: "",
  })

  const [error, setError] = useState({})

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }))
  }

  const savePortfolio = async e => {
    e.preventDefault()

    const errors = {}
    if (!PortfolioName) errors.PortfolioName = "Portfolio name is required"
    if (!SelectedCaseStudies.length)
      errors.CaseStudies = "Select at least one case study"

    setError(errors)
    if (Object.keys(errors).length > 0) return

    const payload = {
      portfolio_name: PortfolioName,
      is_lead_type: Ptype, // boolean (true/false) or 1/0
      lead_id: Lead.value,
      lead_company_name: companyName || "",
      lead_email: leadEmail || "",
      lead_contact: leadContact || "",
      lead_website: website || "",
      caseStudyIds: SelectedCaseStudies.map(cs => cs.value)?.join(","),
    }

    try {
      setLoading(true)

      const response = await axios.put(
        `${configure.nodeApi}/portfolio/${id}`,
        payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )

      setLoading(false)
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Portfolio saved successfully!",
      })
      setTimeout(() => {
        navigate(`${configure.appUrl}portfolio`)
      }, 1000)
    } catch (error) {
      setLoading(false)
      console.error("Error saving portfolio:", error)

      swal({
        icon: "error",
        title: "Error",
        text: "Failed to save portfolio. Please try again.",
      })
    }
  }

  const groupedByService = useMemo(() => {
    const grouped = {}
    SelectedCaseStudies.forEach(study => {
      const service = study.services || "Unknown"
      if (!grouped[service]) grouped[service] = []
      grouped[service].push(study)
    })
    return grouped
  }, [SelectedCaseStudies])

  const handleApplyFilter = e => {
    e.preventDefault()
    const filtered = CaseStudies.filter(item => {
      const matchesLocation =
        !filters.location || item.location === filters.location.value
      const matchesService =
        !filters.service || item.services === filters.service.value
      const matchesTechnology =
        !filters.technology || item.technology === filters.technology.value
      return matchesLocation && matchesService && matchesTechnology
    })

    setFilteredCaseStudies(filtered)
  }

  return (
    <div className="page-content mb-3">
      {isLoading && <Loader />}
      <Container fluid>
        <Breadcrumbs title="Dashboard" breadcrumbItem="Edit Portfolio" />
        <Row className="px-1">
          <Form onSubmit={savePortfolio}>
            <Row className="bg-white px-2 py-4 shadow mb-3">
              <div className="col-md-6 mb-3">
                <h5 className="mb-3">Portfolio Information</h5>
              </div>
              <div className="col-md-6 mb-3 text-end">
                <button type="submit" className="btn btn-save btn-label">
                  <i className="fas fa-save me-1 label-icon" /> Save
                </button>
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="btn btn-red btn-label ms-2"
                >
                  <i className="dripicons-cross me-2 label-icon" /> Cancel
                </button>
              </div>
              <div className="col-md-12 mb-3">
                <div className="row">
                  <div className="col-md-3">
                    <label>Filter by Location</label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Location"
                      onChange={e => handleFilterChange("location", e)}
                      options={generalLocation}
                    ></Select>
                  </div>
                  <div className="col-md-4">
                    <label>Filter by Service</label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Service"
                      onChange={e => handleFilterChange("service", e)}
                      options={serviceOption}
                    ></Select>
                  </div>
                  <div className="col-md-4">
                    <label>Filter by Technology</label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Technology"
                      onChange={e => handleFilterChange("technology", e)}
                      options={techOptions}
                    ></Select>
                  </div>
                  <div className="col-md-1 mt-4">
                    <button
                      onClick={e => handleApplyFilter(e)}
                      className="btn btn-outline-secondary  me-3"
                    >
                      <i className="fas fa-filter"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <label>
                  Select Case Studies <span className="text-danger">*</span>
                </label>
                <Select
                  isMulti
                  className="basic-multi-select"
                  placeholder="Select Case Studies"
                  classNamePrefix="border-radius select"
                  value={SelectedCaseStudies}
                  onChange={selectedOption =>
                    setSelectedCaseStudies(selectedOption)
                  }
                  loading={isLoading}
                  options={FilteredCaseStudies}
                ></Select>
                {error.CaseStudies && (
                  <span className="text-danger">{error.CaseStudies}</span>
                )}
              </div>
              {/* Portfolio Name */}
              <div className="col-md-4 mb-3">
                <label>
                  Portfolio Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Portfolio Name"
                  value={PortfolioName}
                  onChange={e => setPortfolioName(e.target.value)}
                />
                {error.PortfolioName && (
                  <span className="text-danger">{error.PortfolioName}</span>
                )}
              </div>
              <div className="col-md-2 mb-3">
                <label>
                  Portfolio Type <span className="text-danger">*</span>
                </label>
                <div>
                  <Switch
                    checked={Ptype}
                    className="mt-1"
                    checkedChildren="Lead"
                    unCheckedChildren="General"
                    style={{ fontSize: "14px" }}
                    onChange={e => {
                      setPtype(e)
                      if (e) {
                        fetchLData() // Only fetch leads when Lead type is selected
                      } else {
                        // Clear all lead-related fields when switched off
                        setLead(null)
                        setCompanyName("")
                        setLeadEmail("")
                        setLeadContact("")
                        setWebsite("")
                      }
                    }}
                  />
                </div>
              </div>
              {/* Lead Selection */}
              {Ptype && (
                <div className="col-md-4 mb-3">
                  <label>
                    Lead <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="basic-multi-select"
                    classNamePrefix="border-radius select"
                    placeholder="Select Lead"
                    value={Lead}
                    onChange={selectedOption => {
                      setLead(selectedOption),
                        setCompanyName(selectedOption?.company)
                      setLeadEmail(selectedOption?.email)
                      setLeadContact(selectedOption?.contact)
                      setWebsite(selectedOption?.website)
                      setLeadContact(selectedOption?.phonenumber)
                    }}
                    options={Leads}
                  ></Select>
                  {error.Lead && (
                    <span className="text-danger">{error.Lead}</span>
                  )}
                </div>
              )}
            </Row>
            {Ptype && (
              <Row className="bg-white px-2 py-4 shadow mt-3">
                <div className="col-12 mb-3">
                  <h5 className="mb-3">Lead & Company Information</h5>
                </div>

                {/* Company Name */}
                <div className="col-md-4 mb-3">
                  <label>Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Company Name"
                    value={companyName}
                    onChange={e => setCompanyName(e.target.value)}
                  />
                </div>

                {/* Lead Email */}
                <div className="col-md-4 mb-3">
                  <label>Lead Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email"
                    value={leadEmail}
                    onChange={e => setLeadEmail(e.target.value)}
                  />
                </div>

                {/* Lead Contact */}
                <div className="col-md-4 mb-3">
                  <label>Lead Contact</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter Contact"
                    value={leadContact}
                    onChange={e => setLeadContact(e.target.value)}
                  />
                </div>

                {/* Website */}
                <div className="col-md-4 mb-3">
                  <label>Website</label>
                  <input
                    type="url"
                    className="form-control"
                    placeholder="https://example.com"
                    value={website}
                    onChange={e => setWebsite(e.target.value)}
                  />
                </div>
              </Row>
            )}
          </Form>
        </Row>
        {SelectedCaseStudies.length > 0 && (
          <Row className=" px-2 py-4 shadow bg-white mt-3">
            <div className="col-12 mb-3">
              <h5>Selected Case Studies</h5>
            </div>

            {Object.entries(groupedByService).map(([service, studies]) => {
              return (
                <div key={service} className="col-12 mb-4 bg-light p-4">
                  <h5 className="text-dark mb-3">{service}</h5>
                  <div className="row">
                    {studies.map(cs => {
                      let projectImages = []
                      try {
                        if (cs.project_image) {
                          projectImages = JSON.parse(cs.project_image).map(
                            img => img.replace(/\\/g, "/")
                          )
                        }
                      } catch (err) {
                        console.error("Error parsing project_image:", err)
                      }
                      return (
                        <div key={cs.value} className="col-md-3 mb-3 cursor-pointer" onClick={() => navigate(
                          `${configure.appUrl}view-case-study/${cs?.id}`
                        )}>
                          <div className="card  shadow-sm">
                            <img
                              src={
                                projectImages
                                  ? `${configure.nodeImgApi}/${projectImages[0]}`
                                  : ''
                              }
                              className="object-fit-cover card-img-top"
                              alt={cs.label}
                              style={{ height: "250px", objectFit: "cover" }}
                            />
                            <div className="card-body">
                              <h6 className="card-title text-left text-purple">
                                {cs.label}
                              </h6>
                              <div className="d-flex justify-content-between">
                                <div className="fw-bolder text-dark ">
                                  <h6 className="fst-italic fw-medium">{cs?.technologies?.map((obj, i, arr) => (
                                    <span className="" key={i}>
                                      {obj}{i < arr.length - 1 ? ', ' : ''}
                                    </span>
                                  ))}</h6>
                                </div>
                              </div>
                              <h6 className="lh-base case-desc" dangerouslySetInnerHTML={{ __html: cs.project_overview?.slice(0, 100) }} />
                            </div>
                          </div>
                        </div>
                      )
                    }
                    )}
                  </div>
                </div>
              )
            })}
          </Row>
        )}
      </Container>
    </div>
  )
}

export default EditPortfolio
